import { render, staticRenderFns } from "./ELDialog.vue?vue&type=template&id=55268bcb&scoped=true&"
import script from "./ELDialog.vue?vue&type=script&lang=js&"
export * from "./ELDialog.vue?vue&type=script&lang=js&"
import style0 from "./ELDialog.vue?vue&type=style&index=0&id=55268bcb&scoped=true&lang=less&"
import style1 from "./ELDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55268bcb",
  null
  
)

component.options.__file = "ELDialog.vue"
export default component.exports